<template>
  <div class="share_preview_wrap" @click="$emit('click')">
    <div class="share_preview_image">
      <img :src="image" :alt="imageAlt" />
    </div>
    <div class="share_preview_text">
      <div class="share_preview_title">{{ title }}</div>
<!--      <div class="share_preview_desc">{{ desc }}</div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "SharePreview",
  props: {
    title: {
      type: String,
      default: "Facebook Share Title"
    },
    desc: {
      type: String,
      default: "Share Description"
    },
    image: {
      type: String,
      default: require("../../assets/image.jpg")
    },
    imageAlt: {
      type: String,
      default: "Cool Scenery"
    }
  }
};
</script>

<style scoped lang="scss">
.share_preview_wrap {
  max-width: 520px;
  width: 100%;
  margin-top: 30px;
  margin: 30px auto 0;
  background: #f1efef;
  text-align: left;
  font-family: Arial, Helvetica, sans-serif;

  .share_preview_image {
    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }

  .share_preview_text {
    padding: 10px;
    color: black;
    border: 2px solid #979797;
    border-top: 0;
    .share_preview_title {
      font-size: 17px;
      line-height: 22px;
      font-weight: 700;
      margin: 0 0 5px;
    }

    .share_preview_desc {
      font-size: 14px;
      line-height: 20px;
    }
  }
}
</style>
